
import { useSelector } from 'react-redux';
import { useState } from 'react';
import { VIEW_TYPE } from '../../../../../enums/ViewType';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const VisitorTabMainApp = ({ setSubView, selectedList, setSelectedList, setFinalArray, setSearchElement }) => {
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);

    const [view, setView] = useState(VIEW_TYPE.LIST.name);

    const handleSubViewChange = (view) => {
        if (selectedList?.length > 0) setSelectedList([]);
        setSubView(view);
        setFinalArray([]);
        setSearchElement("");
    };

    return {
        DEV,
        permission,
        handleSubViewChange,
        view, setView
    };

};

export default VisitorTabMainApp;
